module.exports = __webpack_public_path__ + "static/media/arrow-down.9440fe2d.svg";